export default "__VITE_ASSET__BI7nyfXG__"